import Header from "./Header";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
function WardsDetails({ setDetails }) {
  const handleClose = () => {
    setDetails(false);
  };
  return (
    <div className="w-full flex flex-column gap-7">
      {/* Page header*/}
      <Header handleClose={handleClose} />
      <div className="flex gap-6">
        <LeftSection />
        <div style={{ width: "100%", overflow: "scroll" }}>
          <RightSection />
        </div>
      </div>
    </div>
  );
}

export default WardsDetails;
